import { Injectable } from "@angular/core";
import {ImpedimentoAfericao} from '@tivic-team/manager-ts/dist/mob/entities/concessao/impedimento-afericao.entity'
import { HttpGet, Quark, Url, HttpResponse } from "sol-request-angular/dist/comunicacao";
import { environment } from "src/environments/environment";


@Injectable()
export class MotivoImpedimentoController{
    constructor() {}

    async getAll():Promise<Array<ImpedimentoAfericao>>{
        let quark = new Quark( 
            new HttpGet({ 
                url: new Url({ 
                    id: 'mob/impedimentoAfericao',
                    environment: environment
                })               
            }),
            new HttpResponse(
                new Array<ImpedimentoAfericao[]>()
            )
        )
        
        return await quark.call();
    }
}